module.exports = __webpack_public_path__ + "img/Insert_drive_file_black.cf30d845.svg";